import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import i from "../utils.js";
import h from "./AxiosHeaders.js";
var c = function c(s) {
  return s instanceof h ? _objectSpread({}, s) : s;
};
function C(s, o) {
  o = o || {};
  var f = {};
  function d(t, e, r) {
    return i.isPlainObject(t) && i.isPlainObject(e) ? i.merge.call({
      caseless: r
    }, t, e) : i.isPlainObject(e) ? i.merge({}, e) : i.isArray(e) ? e.slice() : e;
  }
  function u(t, e, r) {
    if (i.isUndefined(e)) {
      if (!i.isUndefined(t)) return d(void 0, t, r);
    } else return d(t, e, r);
  }
  function a(t, e) {
    if (!i.isUndefined(e)) return d(void 0, e);
  }
  function n(t, e) {
    if (i.isUndefined(e)) {
      if (!i.isUndefined(t)) return d(void 0, t);
    } else return d(void 0, e);
  }
  function l(t, e, r) {
    if (r in o) return d(t, e);
    if (r in s) return d(void 0, t);
  }
  var g = {
    url: a,
    method: a,
    data: a,
    baseURL: n,
    transformRequest: n,
    transformResponse: n,
    paramsSerializer: n,
    timeout: n,
    timeoutMessage: n,
    withCredentials: n,
    withXSRFToken: n,
    adapter: n,
    responseType: n,
    xsrfCookieName: n,
    xsrfHeaderName: n,
    onUploadProgress: n,
    onDownloadProgress: n,
    decompress: n,
    maxContentLength: n,
    maxBodyLength: n,
    beforeRedirect: n,
    transport: n,
    httpAgent: n,
    httpsAgent: n,
    cancelToken: n,
    socketPath: n,
    responseEncoding: n,
    validateStatus: l,
    headers: function headers(t, e) {
      return u(c(t), c(e), !0);
    }
  };
  return i.forEach(Object.keys(Object.assign({}, s, o)), function (e) {
    var r = g[e] || u,
      m = r(s[e], o[e], e);
    i.isUndefined(m) && r !== l || (f[e] = m);
  }), f;
}
export { C as default };
